module.exports = __webpack_public_path__ + "./docs/img/big-icon-namespace.8a58817f09de88ecaf4dd3897e66654a.svg";